export const getFilters = async (store) => {
  const roleId = Array.isArray(store.roles) ? Number(store.roles[0]) : -1;

  // 🔗 Повний набір запитів (функції для лінивого виклику)
  const allRequests = {
    advertiser_id: () => store.requestGet('Advertisers/getList'),
    offer_id: () => store.requestGet('Offers/getOffersList'),
    landing_id: () => store.requestGet('Offers/getLandingsList'),
    app_id: () => store.requestGet('PWA/getAppsList'),
    fb_bayer_id: () => store.requestGet('Traffics/Facebook/getBayersList'),
    inf_bayer_id: () => store.requestGet('Traffics/Influence/getBayersList'),
    fb_traffic_id: () => store.requestGet('Traffics/Facebook/getCompaniesList'),
    inf_traffic_id: () => store.requestGet('Traffics/Influence/getTraffics'),
    pixel_id: () => store.requestGet('Pixels/getPixels'),
    app_service_id: () => store.requestGet('Apps/getServicesList'),
    brand_id: () => store.requestGet('Brands/getBrands'),
    country_id: () => store.requestGet('Countries/getList'),
    inf_link_id: () => store.requestGet('traffics/influence/source/list'),
    fb_link_id: () => store.requestGet('Traffics/Facebook/getLinksList'),
    bot_id: () => store.requestGet('Bots/getListBots'),
    channel_id: () => store.requestGet('Channels/getChannelsList'),
    tg_account_id: () => store.requestGet('TgAccounts/getTgAccounts'),
    channel_group_id: () => store.requestGet('Content/getGroups'),
    manager_id: () => store.requestGet('sales/ltc/manager/list'),
    team_id: () => store.requestGet('sales/ltc/team/list'),
  };

  // 🧩 Запити для кожної конкретної ролі
  const requestsByRole = {
    8: {
      inf_bayer_id: () => store.requestGet('Traffics/Influence/getBayersList'),
      fb_traffic_id: () => store.requestGet('Traffics/Facebook/getCompaniesList'),
      inf_traffic_id: () => store.requestGet('Traffics/Influence/getTraffics'),
      bot_id: () => store.requestGet('Bots/getListBots'),
      channel_id: () => store.requestGet('Channels/getChannelsList'),
      tg_account_id: () => store.requestGet('TgAccounts/getTgAccounts'),
      manager_id: () => store.requestGet('sales/ltc/manager/list'),
      brand_id: () => store.requestGet('Brands/getBrands'),
      country_id: () => store.requestGet('Countries/getList'),
    },
    30: {
      inf_bayer_id: () => store.requestGet('Traffics/Influence/getBayersList'),
      fb_traffic_id: () => store.requestGet('Traffics/Facebook/getCompaniesList'),
      inf_traffic_id: () => store.requestGet('Traffics/Influence/getTraffics'),
      bot_id: () => store.requestGet('Bots/getListBots'),
      channel_id: () => store.requestGet('Channels/getChannelsList'),
      tg_account_id: () => store.requestGet('TgAccounts/getTgAccounts'),
      manager_id: () => store.requestGet('sales/ltc/manager/list'),
      brand_id: () => store.requestGet('Brands/getBrands'),
      country_id: () => store.requestGet('Countries/getList'),
    },
    16: {
      inf_bayer_id: () => store.requestGet('Traffics/Influence/getBayersList'),
      bot_id: () => store.requestGet('Bots/getListBots'),
      channel_id: () => store.requestGet('Channels/getChannelsList'),
      tg_account_id: () => store.requestGet('TgAccounts/getTgAccounts'),
      manager_id: () => store.requestGet('sales/ltc/manager/list'),
      brand_id: () => store.requestGet('Brands/getBrands'),
      country_id: () => store.requestGet('Countries/getList'),
    },
    40: {
      manager_id: () => store.requestGet('sales/ltc/manager/list'),
      brand_id: () => store.requestGet('Brands/getBrands'),
      country_id: () => store.requestGet('Countries/getList'),
    },
    17: {
      inf_bayer_id: () => store.requestGet('Traffics/Influence/getBayersList'),
      bot_id: () => store.requestGet('Bots/getListBots'),
      channel_id: () => store.requestGet('Channels/getChannelsList'),
      tg_account_id: () => store.requestGet('TgAccounts/getTgAccounts'),
      manager_id: () => store.requestGet('sales/ltc/manager/list'),
      brand_id: () => store.requestGet('Brands/getBrands'),
      country_id: () => store.requestGet('Countries/getList'),
    },
    9: {
      bot_id: () => store.requestGet('Bots/getListBots'),
      channel_id: () => store.requestGet('Channels/getChannelsList'),
      tg_account_id: () => store.requestGet('TgAccounts/getTgAccounts'),
      brand_id: () => store.requestGet('Brands/getBrands'),
      country_id: () => store.requestGet('Countries/getList'),
    },
    15: {
      bot_id: () => store.requestGet('Bots/getListBots'),
      channel_id: () => store.requestGet('Channels/getChannelsList'),
      tg_account_id: () => store.requestGet('TgAccounts/getTgAccounts'),
      brand_id: () => store.requestGet('Brands/getBrands'),
      country_id: () => store.requestGet('Countries/getList'),
    },
  };

  const selectedRequests = roleId in requestsByRole ? requestsByRole[roleId] : allRequests;

  const keys = Object.keys(selectedRequests);
  const results = await Promise.all(keys.map((key) => selectedRequests[key]()));

  const data = Object.fromEntries(keys.map((key, index) => [key, results[index]]));

  // 🧩 Статичні фільтри
  const filtersObj = {
    ...data,
    cogort: [
      {
        name: 'Чат - Квалификация',
        id: 'appeals-qualification',
        withDateRange: {
          range_1: ['Квалификация', 'time_start_qualification', 'time_end_qualification'],
          range_2: ['Чат', 'time_start_appeals', 'time_end_appeals'],
        },
      },
    ],
    type: [
      {name: 'Facebook', id: 'facebook'},
      {name: 'Influence', id: 'influence'},
    ],
    state: [{name: 'С Данными', id: 'with_data'}],
  };

  const excludedKeys = ['app_type', 'state', 'traffic_type', 'country_id', 'cohort'];

  Object.entries(filtersObj).forEach(([key, value]) => {
    if (
      !excludedKeys.includes(key) &&
      Array.isArray(value) &&
      value.every((v) => v?.id !== undefined)
    ) {
      value.sort((a, b) => Number(b.id) - Number(a.id));
    }
  });

  return filtersObj;
};
